import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const AdminRequestModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "AdminRequestModalContainer" */
      './AdminRequestModalContainer'
    ),
  loading: LoadingModal,
});
